import React from "react";
import {translatePartnerText} from '../../locales/language';

import Desktop1x from "./images/preview/desktop-1x.webp";
import Desktop2x from "./images/preview/desktop-2x.webp";
import Large1x from "./images/preview/large-1x.webp";
import Large2x from "./images/preview/large-2x.webp";
import Medium1x from "./images/preview/medium-1x.webp";
import Medium2x from "./images/preview/medium-2x.webp";
import Small1x from "./images/preview/small-1x.webp";
import Small2x from "./images/preview/small-2x.webp";
import Mobile1x from "./images/preview/mobile-1x.webp";
import Mobile2x from "./images/preview/mobile-2x.webp";

type BrowserPreviewImageProps = {
    className: string;
    sizes: string;
};

function BrowserPreviewImage({className, sizes}: BrowserPreviewImageProps) {
    return (
        <picture>
            <source
                media="(min-width: 1200px)"
                srcSet={`${Desktop1x} 944w, ${Desktop2x} 1888w`}
                sizes={sizes}
                width={944}
                height={754}
            />
            <source
                media="(min-width: 992px)"
                srcSet={`${Large1x} 896w, ${Large2x} 1792w`}
                sizes={sizes}
                width={896}
                height={714}
            />
            <source
                media="(min-width: 768px)"
                srcSet={`${Medium1x} 672w, ${Medium2x} 1344w`}
                sizes={sizes}
                width={672}
                height={536}
            />
            <source
                media="(min-width: 576px)"
                srcSet={`${Small1x} 512w, ${Small2x} 1024w`}
                sizes={sizes}
                width={512}
                height={1248}
            />
            <img
                src={Mobile1x}
                srcSet={`${Mobile1x} 256w, ${Mobile2x} 512w`}
                sizes={sizes}
                width={256}
                height={628}
                alt={translatePartnerText('Finding a shipping option')}
                className={className}
                loading="lazy"
                decoding="async"
                draggable="false"
            />
        </picture>
    );
}

export default BrowserPreviewImage;
